import gsoPrivacy from './gso/privacy.md.js';
import gsoTerms from './gso/terms.md.js';
import gsoAda from './gso/ada.md.js';
import gsoSitemap from './gso/sitemap.json';
import apexNcPrivacy from './apex-nc/privacy.md.js';
import apexNcTerms from './apex-nc/terms.md.js';
import apexNcAda from './apex-nc/ada.md.js';
import apexNcSitemap from './apex-nc/sitemap.json';
import apexTnPrivacy from './apex-tn/privacy.md.js';
import apexTnTerms from './apex-tn/terms.md.js';
import apexTnAda from './apex-tn/ada.md.js';
import apexTnSitemap from './apex-tn/sitemap.json';

const data = {
  gso:        { privacy: gsoPrivacy,    terms: gsoTerms,    ada: gsoAda,    sitemap: gsoSitemap },
  'apex-nc':  { privacy: apexNcPrivacy, terms: apexNcTerms, ada: apexNcAda, sitemap: apexNcSitemap },
  'apex-tn':  { privacy: apexTnPrivacy, terms: apexTnTerms, ada: apexTnAda, sitemap: apexTnSitemap },
};

// Brand key (gso, apex-nc, apex-tn) -> data folder
export function resolveLegalGroup(brandKey) {
  if (!brandKey) return 'gso';
  if (brandKey === 'gso') return 'gso';
  if (brandKey === 'apex-tn') return 'apex-tn';
  if (brandKey === 'apex-nc' || brandKey.startsWith('apex')) return 'apex-nc';
  return 'gso';
}

export function getLegalContent(brandKey, slug) {
  const group = resolveLegalGroup(brandKey);
  return data[group]?.[slug] ?? null;
}

export const LEGAL_LAST_UPDATED = '2026-05-28';

export default data;
